import { inject, Injectable } from '@angular/core';

import { UISocketDataMessage } from 'app/shared/models/UISocket';
import { SocketAction, SocketActionHandler } from 'app/shared/services/SocketActionHandler';

import { DeviceCommandsStore } from '../device-commands.store';
import { DeviceDetailStore } from '../device-detail.store';
import { DeviceId } from '../models/Device';
import { SiteId } from '../models/Site';
import { SiteDevicesStore } from '../site-devices.store';

import { DEVICE_GATEWAY } from './DeviceGateway';

export interface UISocketDeviceStateUpdateMessage extends UISocketDataMessage {
    deviceId: DeviceId;
    siteId: SiteId;
    states: { name: string; value: string }[];
}

@Injectable()
export class DeviceStatesUpdatedHandler implements SocketActionHandler {
    readonly action: SocketAction = 'deviceStatesUpdated';

    private readonly deviceGateway = inject(DEVICE_GATEWAY);
    private readonly siteDevices = inject(SiteDevicesStore);
    private readonly deviceDetail = inject(DeviceDetailStore);
    private readonly deviceCommands = inject(DeviceCommandsStore);

    handle(message: UISocketDeviceStateUpdateMessage): void {
        message.states.forEach((state) => this.deviceDetail.stateUpdated(message.deviceId, state.name, state.value));
        this.updateSiteDevice(message.siteId, message.deviceId);
        this.deviceCommands.statesReported(
            message.deviceId,
            message.states.map((state) => state.name),
        );
    }

    private updateSiteDevice(id_site: string, id_device: string) {
        // The socket only carries the changed states: fetch the whole device.
        this.deviceGateway.getDeviceById(id_device).subscribe((newDevice) => {
            this.siteDevices.deviceUpdated(id_site, newDevice);
        });
    }
}
